import React, { useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import './UsersList.css';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";
import { Col, Container, Form, Row, Modal, Button } from "react-bootstrap"; // ✅ Added Modal & Button
import useAuth from "../../hooks/useAuth";
import { useRef } from "react";
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import { fetchPranthList } from './pranthService'; // Adjust path as needed

const AdminKhandArppanDetails = () => {

  const [gurudakshinas, setGurudakshinas] = useState([]);
  const [gurudakshinaFinalizationStatus, setGurudakshinasFinalizationStatus] = useState([]);
  const [FinalSubmissionList, setFinalSubmissionList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const gurudakshinaPerPage = 50;
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [pranthNames, setPranthNames] = useState({});
  const [selectedSakha, setSelectedSakha] = useState("");
  const [pranthList, setPranthList] = useState([]);
  const [sakhaList, setSakhaList] = useState([]);

  const [proudaSubmitted, setProudaSubmitted] = useState(false);
  const [vidyarthiSamyukthaSubmitted, setVidyarthiSamyukthaSubmitted] = useState(false);
  const [vidyarthiTharunaSubmitted, setVidyarthiTharunaSubmitted] = useState(false);
  const [vyavasayiTharunaSubmitted, setVyavasayiTharunaSubmitted] = useState(false);

  const [sakhaSubmitted, setSakhaSubmitted] = useState("");

  const [errMsg, setErrMsg] = useState("");
  const [sucssMsg, setSucssMsg] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const errRef = useRef();



  const [selectedPranthId, setSelectedPranthId] = useState(1);
  const [selectedVibhagId, setSelectedVibhagId] = useState("");
  const [vibhagList, setVibhagList] = useState([]);
  const [selectedJillaId, setSelectedJillaId] = useState("");
  const [jillaList, setJillaList] = useState([]);
  const [Sthans, setSthans] = useState([]);
  const [ArthikSakhaList, setArthikSakhaList] = useState([]);

  const [selectedArthikSakhaId, setSelectedArthikSakhaId] = useState("");
  const [hasSearched, setHasSearched] = useState(false); // 👈 NEW

  useEffect(() => {
    const getPranths = async () => {
      const data = await fetchPranthList(); // Get data from the service
      setPranthList(data);                  // Set data to state
    };

    getPranths();
  }, []);

  useEffect(() => {
    if (selectedPranthId) {
      fetchVibhagList(selectedPranthId).then((vibhags) => {
        if (vibhags.length > 0) {
          setSelectedVibhagId(vibhags[0].vibhag_id);
        } else {
          setSelectedVibhagId("");
          setVibhagList([]);
          setSelectedJillaId("");
          setJillaList([]);

          setSelectedArthikSakhaId("");        // ✅ Add this line

          setError("No vibhags for selected pranth");
        }
      });
    }
  }, [selectedPranthId]);

  const fetchVibhagList = async (pranthId) => {
    try {
      const res = await axiosPrivate.get(`list-vibhags?pranth_id=${pranthId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setVibhagList(data);
      return data;
    } catch (err) {
      console.error("Failed to fetch vibhags", err);
      setVibhagList([]);
      return [];
    }
  };

  const fetchJillaList = useCallback(async () => {
    try {
      const res = await axiosPrivate.get(`list-jillas?vibhag_id=${selectedVibhagId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setJillaList(data);
      if (data.length > 0) {
        setSelectedJillaId(data[0].jilla_id); // default selection
      } else {
        setSelectedJillaId("");
      }
    } catch (err) {
      console.error("Jilla fetch failed:", err);
      setError("Failed to load jilla list");
      setJillaList([]);
      setSelectedJillaId("");
    }
  }, [axiosPrivate, selectedVibhagId]);

  useEffect(() => {
    if (selectedVibhagId) {
      fetchJillaList();
    }
  }, [selectedVibhagId]);

  const fetchArthiksakha = useCallback(async () => {
    if (!selectedJillaId) return;


    try {
      const res = await axiosPrivate.get(`list-arthik-sakhas?jilla_id=${selectedJillaId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setArthikSakhaList(data);
      if (data.length > 0) {
        setSelectedArthikSakhaId(data[0].arthik_sakha_id); // optional default
      } else {
        setSelectedArthikSakhaId("");
      }
    } catch (err) {
      console.error("Arthiksakha fetch failed:", err);
      setError("Failed to load Arthiksakha list");
      setArthikSakhaList([]);
      setSelectedArthikSakhaId("");
    } finally {
      setLoading(false);
    }
  }, [axiosPrivate, selectedJillaId]);

  useEffect(() => {
    if (selectedJillaId) {
      fetchArthiksakha();
    }
  }, [selectedJillaId]);


  const fetchArppanSummary = useCallback(async () => {
    if (!selectedArthikSakhaId) return;  // 🛑 Prevent API call if undefined or empty
    setLoading(true);
    setHasSearched(true);
    setError(null);
    try {
      // Construct the URL first
      const url = `get-khand-wise-arppan-summary?arthik_sakha_id=${selectedArthikSakhaId}`;

      const response = await axiosPrivate.get(url, { withCredentials: true });
      setGurudakshinas(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Data:", error);
      setError(error?.response?.data?.message || "No Data available.");
      setLoading(false);
    }
  }, [axiosPrivate, selectedArthikSakhaId]);



  useEffect(() => {
    fetchArppanSummary();
  }, [selectedArthikSakhaId]);



  const indexOfLastGurudakshina = currentPage * gurudakshinaPerPage;
  const indexOfFirstGurudakshina = indexOfLastGurudakshina - gurudakshinaPerPage;
  const currentgurudakshinas = gurudakshinas.slice(indexOfFirstGurudakshina, indexOfLastGurudakshina);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(gurudakshinas.length / gurudakshinaPerPage);

  // if (loading) {
  //   return <div className="loading">Loading...</div>;
  // }

  return (
    <>
      <section className="empbody">
        <div className="wrapperemp2">
          {/* ✅ Finalize Button with Modal trigger */}
          <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>


          <div className="d-flex justify-content-end align-items-center gap-2 mb-3">



          </div>

          <h3>Khand Arppan Details</h3>


          <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
            <Modal.Header closeButton>
              {/* <Modal.Title>Success</Modal.Title> */}
            </Modal.Header>
            <Modal.Body>
              <p>{sucssMsg}</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" onClick={() => setShowSuccessModal(false)}>
                OK
              </Button>
            </Modal.Footer>
          </Modal>
          <Row>
            {/* <Col md={3}>
              <Form.Label className="newformstyle">Pranth</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedPranthId}
                onChange={(e) => {
                  const pranthId = e.target.value;
                  setSelectedPranthId(pranthId);

                  if (!pranthId) {
                    // Clear vibhag, jilla, and table if no Pranth selected
                    setVibhagList([]);
                    setSelectedVibhagId("");
                    setJillaList([]);
                    setSelectedJillaId("");
                    // setSthans([]);

                    setArthikSakhaList([]);
                    setSelectedArthikSakhaId("");
                  }
                }}
              >
                <option value="">-- Select Pranth --</option>
                {pranthList.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.name}
                  </option>
                ))}
              </Form.Select>

            </Col> */}

            <Col md={3}>
              <Form.Label className="newformstyle">Vibhag</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedVibhagId}
                onChange={(e) => {
                  const vibhagId = e.target.value;
                  setSelectedVibhagId(vibhagId);

                  if (!vibhagId) {
                    // Clear Jilla list and selection if no Vibhag selected
                    setJillaList([]);
                    setSelectedJillaId("");
                    setSthans([]); // Optional: clear table too

                    setArthikSakhaList([]);
                    setSelectedArthikSakhaId("");
                  }
                }}
                disabled={!vibhagList.length}
              >
                <option value="">-- Select Vibhag --</option>
                {Array.isArray(vibhagList) &&
                  vibhagList.map((v) => (
                    <option key={v.vibhag_id} value={v.vibhag_id}>
                      {v.vibhag_name}
                    </option>
                  ))}
              </Form.Select>
            </Col>

            <Col md={3}>
              <Form.Label className="newformstyle">Jilla</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedJillaId}
                onChange={(e) => {
                  const jillaId = e.target.value;
                  setSelectedJillaId(jillaId); // ✅ Just update state


                  if (!jillaId) {
                    setArthikSakhaList([]);
                    setSelectedArthikSakhaId("");
                    // setSthans([]);
                  }
                }}
                disabled={!jillaList.length}
              >
                <option value="">-- Select Jilla --</option>
                {jillaList.map((j) => (
                  <option key={j.jilla_id} value={j.jilla_id}>
                    {j.jilla_name}
                  </option>
                ))}
              </Form.Select>

            </Col>

            <Col md={3}>
              <Form.Label className="newformstyle">Arthiksakha</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedArthikSakhaId}
                onChange={(e) => setSelectedArthikSakhaId(e.target.value)}
                disabled={!ArthikSakhaList.length}
              >
                <option value="">-- Select Arthiksakha --</option>
                {ArthikSakhaList.map((k) => (
                  <option key={k.arthik_sakha_id} value={k.arthik_sakha_id}>
                    {k.arthik_sakha}
                  </option>
                ))}
              </Form.Select>

            </Col>





          </Row>


          <div className="table-container">

            {hasSearched && (
              <table id="customers">
                <thead>
                  <tr>
                    {/* <th>Vibhag</th> */}
                    {/* <th>Jilla</th> */}
                    {/* <th>Arthiksakha</th> */}
                    {/* <th>Khand</th>
                  <th>Mandal</th> */}
                    <th>khand name</th>
                    <th>Total sthans</th>
                    <th>Arppan sthan</th>
                    <th>Arppan upasthithi</th>
                    <th>Amount</th>
                    {/* <th>Options</th> */}
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="5" className="text-center text-primary">
                        Loading...
                      </td>
                    </tr>
                  ) : error ? (
                    <tr>
                      <td colSpan="6" className="text-danger text-center">
                        {error}
                      </td>
                    </tr>
                  ) : gurudakshinas.length === 0 ? (
                    <tr>
                      <td colSpan="6">No Data available.</td>
                    </tr>
                  ) : (
                    currentgurudakshinas.map(gurudakshina => (
                      <tr key={gurudakshina.id}>

                        {/* <td>{gurudakshina.vibhag_name}</td> */}
                        {/* <td>{gurudakshina.jilla_name}</td> */}
                        {/* <td>{gurudakshina.arthik_sakha}</td> */}
                        {/* <td>{gurudakshina.khand_name}</td>
                      <td>{gurudakshina.mandal_name}</td> */}
                        <td>{gurudakshina.khand_name}</td>
                        <td>{gurudakshina.total_sthans}</td>
                        <td>{gurudakshina.arppan_sthan}</td>
                        <td>{gurudakshina.arppan_upasthithi}</td>
                        <td>{gurudakshina.amount}</td>



                        {/* <td>
                        <div className="d-flex justify-content-center">
                          <button type="button" className="btn btn-info btn-ico newicobtn" onClick={() => handleViewClick(gurudakshina.id)}>
                            <i className="bx bxs-show icon"></i>
                          </button>
                          <button type="button" className="btn btn-warning btn-ico newicobtn" onClick={() => handleEditClick(gurudakshina.id)}>
                            <i className="bx bxs-edit icon"></i>
                          </button>
                        </div>
                      </td> */}
                      </tr>
                    ))
                  )}
                </tbody>


              </table>
            )}
          </div>
          <div className="table-container">
            {totalPages > 1 && (
              <div className="pagination">
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
                {Array.from({ length: totalPages }, (_, index) => (
                  <button
                    key={index}
                    onClick={() => handlePageChange(index + 1)}
                    disabled={currentPage === index + 1}
                  >
                    {index + 1}
                  </button>
                ))}
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
              </div>
            )}
          </div>
        </div >
      </section >


      <TopBar />
    </>
  );
};

export default AdminKhandArppanDetails;
